import { render, staticRenderFns } from "./loaction.vue?vue&type=template&id=00b0bac8&"
import script from "./loaction.vue?vue&type=script&lang=js&"
export * from "./loaction.vue?vue&type=script&lang=js&"
import style0 from "./loaction.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports